import { useState } from "react";
import { cartItemsVar } from "../Utils/cache";
import { useReactiveVar } from "@apollo/client";
import { ADD_CARTS } from "../Utils/Mutations";
import { useMutation } from "@apollo/client";
import { useSnackbar } from "notistack";

const useAddToCarts = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [isSuccess, setSuccess] = useState(false);
  const { enqueueSnackbar } = useSnackbar();

  const handleAlert = (variant, message) => {
    // variant could be success, error, warning, info, or default
    enqueueSnackbar(message, { variant });
  };

  const cartItems = useReactiveVar(cartItemsVar);

  const [addCart, { data }] = useMutation(ADD_CARTS);

  const handleAddToCart = async (product_id, productQuantity) => {
    let isInCart = cartItems?.some((item) => item?.product?._id === product_id);

    const payload = { product: product_id, quantity: productQuantity };

    if (!isInCart) {
      setIsLoading(true);
      await addCart({
        variables: payload,
      })
        .then((res) => {
          setIsLoading(false);
          setSuccess(true);
          // Update local cache immediately with the new item
          cartItemsVar([...cartItems, res?.data?.addToCart]);
          // Store the updated cart in localStorage as backup
          const updatedCart = [...cartItems, res?.data?.addToCart];
          localStorage.setItem('tempCartItems', JSON.stringify(updatedCart));
        })
        .catch((err) => {
          setIsLoading(false);

          const errorMessage = err?.graphQLErrors?.[0]?.message;

          if (errorMessage === "You can not select your own product.") {
            handleAlert("error", errorMessage);
          } else {
            handleAlert("error", "Something went wrong while adding to cart.");
          }

          console.error("Error New Cart", err);
        });
    } else {
      handleAlert("warning", `Item is already in your cart.`);
    }
  };

  return { handleAddToCart, isLoading, isSuccess };
};

export default useAddToCarts;
